import { useContext } from 'react';
import { IsDisabledContext } from './IsDisabledContext';

export function useIsDisabled(localProp: boolean = false): boolean {
  return useContext(IsDisabledContext) || localProp;
}
